/**
 * Auth maintenance is intentionally hardcoded here (not VITE_* or any env var).
 * Set to false in this file when login, registration, and sessions are allowed again.
 */
export const AUTH_MAINTENANCE_ENABLED = false

export const AUTH_MAINTENANCE_BODY =
  'We are performing scheduled maintenance on sign-in and new account registration. For security, existing sessions have been signed out. We expect to be back online shortly.'

export const AUTH_MAINTENANCE_AUTH_UNAVAILABLE =
  'Sign-in and registration are temporarily unavailable while we perform maintenance.'

/**
 * Order editing kill switch (hotfix).
 *
 * Hardcoded here rather than behind an env var, matching AUTH_MAINTENANCE
 * above, so turning it back on is a one-line change with a diff someone can
 * review rather than a container setting that has to be remembered.
 *
 * Set to false to restore editing. Everything gated on this references
 * ORDER_EDITING_DISABLED, so the whole hotfix can be removed by deleting those
 * references and this block.
 *
 * Covers changing item quantities and adding a product. Pausing a delivery and
 * booking a holiday are deliberately still allowed: they do not alter what is
 * on the order.
 */
export const ORDER_EDITING_DISABLED = false

export const ORDER_EDITING_DISABLED_TITLE = 'Editing temporarily unavailable'

export const ORDER_EDITING_DISABLED_MESSAGE =
  "Sorry, you can't make changes to your order right now while we carry out " +
  "some updates. If your change is urgent, please call us on 0330 555 5588 " +
  "and we'll be happy to help."

/**
 * Kept apart from the sentence above so the modal can turn it into a tel:
 * link. Most customers hit this on a phone, where a number they have to
 * memorise and retype is a worse answer than one they can tap. It must appear
 * verbatim in the message for that to work, so the two sit together here and
 * it is obvious if one is edited without the other.
 */
export const ORDER_EDITING_DISABLED_PHONE = '0330 555 5588'
